import React, { Fragment } from 'react';
import T from 'prop-types';

import EditingMarketApps from '../EditingMarketApps';
import Modal from '../../../../../../components/Modal';

const EditingMarketModal = ({
  show,
  selectedApps,
  popularApps,
  withChartsRequest,
  onChartsChange,
  onAppsChange,
  onHide,
}) => (
  <Modal
    open={show}
    size="xs"
    hideCloseButton
    shouldCloseOnOverlayClick={false}
    modalClassName="edit-market-modal edit-market-modal-desktop"
    onClose={() => onHide(false)}
  >
    {show && (
      <Fragment>
        <header className="edit-market-modal__header">
          <p className="edit-market-modal__header-title">Edit Market</p>
          <span className="hicon-close" onClick={() => onHide(false)} />
        </header>
        <EditingMarketApps
          selectedApps={selectedApps}
          popularApps={popularApps}
          withChartsRequest={withChartsRequest}
          onClose={onHide}
          onChange={onAppsChange}
          onChartsChange={onChartsChange}
        />
      </Fragment>
    )}
  </Modal>
);

EditingMarketModal.propTypes = {
  show: T.bool.isRequired,
  selectedApps: T.array.isRequired,
  popularApps: T.array.isRequired,
  withChartsRequest: T.bool,
  onChartsChange: T.func,
  onAppsChange: T.func.isRequired,
  onHide: T.func.isRequired,
};

export default EditingMarketModal;
